module.exports = __webpack_public_path__ + "static/media/IMG_1267.d5bc1d49.jpg";